import { useTranslations } from 'next-intl';
import { CheckboxIcon } from '@/component/Icons/CheckboxIcon';
import styles from './Checkbox.module.css';

export const Checkboxes = ({
  options = [],
  value = [],
  onChange,
  dataTestid,
}) => {
  const t = useTranslations();

  return (
    <div className="grid grid-cols-2 gap-6" data-testid={dataTestid}>
      {options.map(({ id, name }) => {
        const checked = !!(value.indexOf(id) + 1);
        return (
          <label
            key={`checkbox-${id}`}
            id={`checkbox-${id}`}
            className={`inline-flex gap-2 items-center ${styles.checkbox}`}
            data-testid={`checkbox-${id}`}
          >
            <input
              name={`checkbox-${id}`}
              checked={checked}
              type="checkbox"
              onChange={() =>
                onChange(
                  checked
                    ? value.toSpliced(value.indexOf(id), 1)
                    : [...value, id],
                )
              }
            />
            <span
              className={`${styles.checkbox_placeholder} ${
                checked ? styles.checkbox_selected : ''
              }`}
              tabIndex={-1}
            >
              {checked && <CheckboxIcon />}
            </span>
            <span className="text-slate-500 text-base font-normal break-all">
              {name}
            </span>
          </label>
        );
      })}
    </div>
  );
};
